import { sort } from '@ember/object/computed';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { FundMapping } from 'donor-elf-web/services/fund-mappings-service';
import fuzzysort from 'fuzzysort';

export default class FundMappingsController extends Controller {
  @service declare fundsService: any;

  queryParams = ['q', 'page', 'inactive'];
  @tracked q = '';
  @tracked page = 1;
  @tracked inactive = false;
  perPage = 100;

  sortBy = ['fund.name:asc'];
  @sort('model.fundMappings', 'sortBy')
  declare sortedItems: FundMapping[];

  get filteredItems() {
    let items = this.sortedItems;
    if (!this.inactive) {
      items = items.filter((x) => x.fund.active);
    }

    let query = this.q?.trim()?.toLowerCase() || '';

    if (query.length === 0) {
      return items;
    }

    if (query.length < 3) {
      let exactMatchOnHostId = items.filter((item) => {
        return (
          item.hostIdentities.find(
            (hostIdentity) => hostIdentity.hostId.toLowerCase() === query,
          ) != null
        );
      });
      return exactMatchOnHostId.length > 0 ? exactMatchOnHostId : items;
    }

    return fuzzysort
      .go(query, items, {
        threshold: -10000,
        key: 'fuzzySortPrepared',
      })
      .map((result) => result.obj);
  }

  get pagedItems() {
    let offset = (this.page - 1) * this.perPage;
    return this.filteredItems.slice(offset, offset + this.perPage);
  }

  get totalPages() {
    return Math.ceil(this.filteredItems.length / this.perPage);
  }

  @action
  templateWillDestroy() {
    this.q = '';
    this.page = 1;
  }

  @action
  toggleInactive() {
    this.inactive = !this.inactive;
  }

  @action
  changePage(pageNumber: number) {
    this.page = pageNumber;
  }

  @action
  handleSearchInput(e: any) {
    this.q = e.target.value;
  }

  @action
  handleSearchEnter(e: any) {
    if (e.target.value !== (this.q || '')) {
      this.handleSearchInput(e);
    }
    let firstItem = this.filteredItems[0];
    if (firstItem) {
      this.viewFund(firstItem.fund.id);
    }
  }

  @action
  viewFund(fundId: string) {
    this.fundsService.viewFund(fundId);
  }
}
